import React, { useState, useEffect } from 'react';

// mui
import { Box, List, Stack } from '@mui/material';

// api
import { AdminObjectAdd, AdminObjectList, AdminObjectRemove, AdminObjectUpdate } from '../../../api';

import { def } from '@goldblack/shared';

// components
import {
    FilterOptionItem,
    LoiseFiltersFilterOptionInfoPanel,
    CommonYesNoDialog,
    AdminMenuBar,
    cloneObject,
} from '../..';

// client-shared
import { ContainerScroll } from '@goldblack/client-comps';
import { storage } from '@goldblack/client-storage';

function LoiseFiltersFilterOptions() {
    const { loise } = storage.transience.getValue();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [openDelete, setOpenDelete] = useState(false);

    function getFilterOption() {
        return loise.filterOption.data[selectedIndex];
    }

    const clickNew = () => {
        AdminObjectAdd('loise', 'filterOption', { name: 'Untitled', options: [] }, () => {
            setSelectedIndex(loise.filterOption.data.length);
        });
    };

    const clickUpdate = () => {
        AdminObjectUpdate('loise', 'filterOption', getFilterOption());
    };

    const clickDelete = () => {
        if (getFilterOption()) setOpenDelete(true);
    };

    const onConfirmDelete = () => {
        setOpenDelete(false);
        AdminObjectRemove('loise', 'filterOption', getFilterOption()._id);
    };

    const clickItem = (index) => {
        setSelectedIndex(index);
    };

    const updateFilterOption = (option) => {
        let callback = (type) => type._id === option._id;
        storage.transience.updateState('loise.filterOption.data', callback, option);
    };

    const clickSetActive = () => {
        let option = cloneObject(getFilterOption());
        option.status = def.FilterStatus.ACTIVE;
        updateFilterOption(option);
    };

    const clickSetInactive = () => {
        let option = cloneObject(getFilterOption());
        option.status = def.FilterStatus.INACTIVE;
        updateFilterOption(option);
    };

    const AdminFilterOptionListPanel = () => {
        return (
            <ContainerScroll>
                <List>
                    {loise.filterOption.data.map((option, index) => (
                        <FilterOptionItem
                            key={option._id}
                            filterOption={option}
                            onClick={() => clickItem(index)}
                            selected={selectedIndex === index}
                        />
                    ))}
                </List>
            </ContainerScroll>
        );
    };

    useEffect(() => {
        if (loise.filterOption.data.length === 0) {
            AdminObjectList('loise', 'filterOption');
        }
    }, []);

    const apiItems = [
        { label: 'New', onClick: clickNew },
        { label: 'Update', onClick: clickUpdate },
        { label: 'Delete', onClick: clickDelete },
    ];

    const editItems = [
        { label: 'Set Active', onClick: clickSetActive },
        { label: 'Set Inactive', onClick: clickSetInactive },
    ];

    return (
        <Stack direction='column' sx={{ p: 0, m: 0, width: '100%', height: '100%', minHeight: 0 }}>
            <CommonYesNoDialog
                open={openDelete}
                onClose={() => setOpenDelete(false)}
                title='Delete Filter Option'
                desc='Are you sure you want to delete this filter option?'
                onYes={onConfirmDelete}
                onNo={() => setOpenDelete(false)}
            />
            <AdminMenuBar apiItems={apiItems} editItems={editItems} />
            <Box sx={{ display: 'flex', flex: 1, minHeight: 0 }}>
                {/* Left column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRight: 1,
                        borderColor: 'primary.main',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        <AdminFilterOptionListPanel />
                    </Box>
                </Box>
                {/* Right column */}
                <Box
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        boxSizing: 'border-box',
                    }}>
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'auto',
                            borderBottom: 1,
                            borderColor: 'primary.main',
                            boxSizing: 'border-box',
                        }}>
                        <LoiseFiltersFilterOptionInfoPanel filterOption={getFilterOption()} />
                    </Box>
                </Box>
            </Box>
        </Stack>
    );
}

export { LoiseFiltersFilterOptions };
